import { render } from "./DetalheLoja.vue?vue&type=template&id=088e1c80"
import script from "./DetalheLoja.vue?vue&type=script&lang=js"
export * from "./DetalheLoja.vue?vue&type=script&lang=js"

import "./DetalheLoja.vue?vue&type=style&index=0&id=088e1c80&lang=css"
script.render = render

export default script